class ProductVariantInfo extends HTMLElement {
  connectedCallback() {
    const script = document.querySelector("script[data-product-variants]");
    if (!script) return;
    try {
      this.variants = JSON.parse(script.textContent);
    } catch (e) {
      console.error("JSON de variantes inválido", e);
      return;
    }

    this.infoBlocks = this.querySelectorAll("info-data[data-name]");
    if (!this.infoBlocks.length) return;

    this.updateInfo(this.getSelectedVariantId());

    document.addEventListener("variant:change", (e) => {
      const variantId = e.detail?.variant?.id || e.detail?.id;
      this.updateInfo(variantId);
    });
  }

  getSelectedVariantId() {
    const input = document.querySelector(
      'form[action*="/cart/add"] [name="id"]:checked, form[action*="/cart/add"] [name="id"]'
    );
    return input ? Number(input.value) : null;
  }

  updateInfo(variantId) {
    const variant = this.variants.find((v) => v.id === Number(variantId));

    if (!variant || !variant.enable) {
      this.style.display = "none";
      return;
    } else {
      this.style.display = "";
    }

    this.infoBlocks.forEach((block) => {
      const field = block.getAttribute("data-name");
      const type = block.getAttribute("data-type") || "text";
      const infoDiv = block.querySelector("[data-info]");
      let value =
        variant && variant[field] !== undefined ? variant[field] : null;

      if (value !== null && value !== undefined && value !== "") {
        infoDiv.textContent = value;
        block.style.display = "";
      } else {
        infoDiv.textContent = "";
        block.style.display = "none";
      }
    });
  }
}

customElements.define("product-variant-info", ProductVariantInfo);
